// extracted by mini-css-extract-plugin
export default {"arrowArray":"ArrowArray_arrowArray__CdzAu","arrow":"ArrowArray_arrow__2bHDX"};